// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import PurchasePage from './pages/PurchasePage';
import SellPage from './pages/SellPage';
import PortfolioPage from './pages/PortfolioPage';
import ScriptMasterPage from './pages/masters/ScriptMasterPage';
import CustomerMasterPage from './pages/masters/CustomerMasterPage';
import BrokerageMasterPage from './pages/masters/BrokerageMasterPage';
import PriceHistoryPage from './pages/masters/PriceHistoryPage';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
};

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="purchase" element={<PurchasePage />} />
        <Route path="sell" element={<SellPage />} />
        <Route path="portfolio" element={<PortfolioPage />} />
        <Route path="masters/scripts" element={<ScriptMasterPage />} />
        <Route path="masters/customers" element={<CustomerMasterPage />} />
        <Route path="masters/brokerage" element={<BrokerageMasterPage />} />
        <Route path="masters/price-history" element={<PriceHistoryPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
